import { styled, Box, Typography, Button, Link } from "@mui/material";

const CARD_RADIUS = "12px";
const CARD_SHADOW = "0 4px 12px rgba(15, 23, 42, 0.08)";
const CARD_PADDING = "24px";
const CARD_MIN_HEIGHT = 280;
const IMPORT_BLUE_BG = "rgba(26, 107, 235, 0.09)";
const IMPORT_BLUE_BORDER = "1px solid rgba(26, 107, 235, 0.35)";

export const ImportsPageRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: theme.spacing(3),
  alignItems: "stretch",
  alignContent: "stretch",
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

export const ImportCardShell = styled(Box, {
  shouldForwardProp: (p) => p !== "$tintBg" && p !== "$border",
})(({ theme, $tintBg, $border }) => ({
  borderRadius: CARD_RADIUS,
  boxShadow: CARD_SHADOW,
  padding: CARD_PADDING,
  flex: "1 1 360px",
  maxWidth: 520,
  minWidth: 280,
  minHeight: CARD_MIN_HEIGHT,
  height: "100%",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  backgroundColor: $tintBg ?? theme.palette.background.paper,
  border: $border ?? "1px solid transparent",
}));

export const ImportPrimaryCard = styled(ImportCardShell)(() => ({
  backgroundColor: IMPORT_BLUE_BG,
  border: IMPORT_BLUE_BORDER,
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "1.125rem",
  lineHeight: 1.3,
  color: "#1a2b4a",
  marginBottom: theme.spacing(2),
  flexShrink: 0,
}));

export const FieldLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.875rem",
  fontWeight: 600,
  color: "#344767",
  marginBottom: theme.spacing(1),
  flexShrink: 0,
}));

export const FileRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  gap: theme.spacing(1.5),
  width: "100%",
  flexWrap: "nowrap",
  flexShrink: 0,
  [theme.breakpoints.down("sm")]: {
    flexWrap: "wrap",
  },
}));

export const ActionRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1.5),
  width: "100%",
  marginTop: theme.spacing(2),
  flexWrap: "wrap",
  flexShrink: 0,
  "& > .MuiButton-root": {
    flex: "1 1 140px",
    minWidth: 120,
  },
}));

export const FileNameBox = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  display: "flex",
  alignItems: "center",
  border: "1px solid rgba(26, 107, 235, 0.45)",
  borderRadius: "8px",
  padding: theme.spacing(1, 1.5),
  backgroundColor: "#fff",
  fontSize: "0.875rem",
  color: "#344767",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

export const UploadButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "8px",
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  flexShrink: 0,
}));

export const ClearLink = styled(Link)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
  display: "inline-block",
  fontSize: "0.875rem",
  fontWeight: 600,
  cursor: "pointer",
  flexShrink: 0,
}));

export const StatusBody = styled(Typography)(() => ({
  fontSize: "0.9375rem",
  lineHeight: 1.5,
  color: "#1a2b4a",
  whiteSpace: "pre-wrap",
  flex: 1,
  minHeight: 0,
}));

export const STATUS_TINT = {
  neutral: "#faf9f8",
  success: "rgba(16, 124, 16, 0.12)",
  warning: "rgba(255, 185, 0, 0.15)",
  error: "rgba(164, 38, 44, 0.12)",
};
